import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from 'react-simple-loading';
import classNames from 'classnames';

import styles from './Pod.css';


export default class Pod extends Component {
  static propTypes = {
    additionalClasses: PropTypes.string,
    bgVariant: PropTypes.oneOf(['rocket', 'connect']),
    children: PropTypes.node,
    footerNode: PropTypes.node,
    loading: PropTypes.bool,
    removePadding: PropTypes.bool,
    style: PropTypes.object,
    title: PropTypes.string,
    titleIcon: PropTypes.node,
    titleNode: PropTypes.node,
  };

  static defaultProps = {
    additionalClasses: undefined,
    bgVariant: undefined,
    children: undefined,
    footerNode: undefined,
    loading: false,
    removePadding: false,
    style: undefined,
    title: undefined,
    titleIcon: undefined,
    titleNode: undefined,
  };

  renderTitle = () => {
    const { title, titleIcon, titleNode } = this.props;

    if (!(title || titleIcon || titleNode)) {
      return null;
    }

    const icon = titleIcon ? <span className={styles.titleIcon}>{titleIcon}</span> : null;
    const text = title ? <h3 className={styles.titleText}>{title}</h3> : null;

    return (
      <div className={styles.header}>
        {icon}
        {text}
        {titleNode}
      </div>
    );
  };

  renderContent = () => {
    const { children, loading, removePadding } = this.props;

    const contentClasses = classNames(
      styles.content,
      { [styles.noPadding]: removePadding },
    );

    const content = loading ? <Loading /> : children;

    return (
      <div className={contentClasses}>
        {content}
      </div>
    );
  };

  renderFooter = () => {
    const { footerNode } = this.props;

    if (!footerNode) {
      return null;
    }

    return (
      <div className={styles.footer}>
        {footerNode}
      </div>
    );
  };

  render() {
    const { additionalClasses, style, bgVariant } = this.props;

    const containerClasses = classNames(
      styles.pod,
      { [styles[bgVariant]]: bgVariant },
      styles[additionalClasses],
    );

    return (
      <div className={containerClasses} style={style}>
        {this.renderTitle()}
        {this.renderContent()}
        {this.renderFooter()}
      </div>
    );
  }
}
